import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
  member_data: any[];
  main_data: any[];
  representative_data: any[];
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";


    const getMembershipCertInfo = async (payload: any) => {
      try {
        const { data } = await axios.post<ApiResponse>(
          `${API_BASE_URL}/get_membership_cert_info/`,
          payload
        );
        return data;
      } catch (error) {
        return error;
      }
    };

    const MembershipCertController = {
        getMembershipCertInfo,
    };

export default MembershipCertController;